// import react from 'react'
import _ from 'lodash'

export const device_type = { Mobile: 'Mobile', WebMobile: 'WebMobile', Web: 'Web' }

export const handleDeviceDetection = () => {
  const userAgent = navigator.userAgent
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) && window.cordova) {
    return device_type.Mobile
  } else if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) && !window.cordova) {
    return device_type.WebMobile
  } else {
    return device_type.Web
  }
}

export const isDeviceOCR = () => {
  const device = handleDeviceDetection()
  console.log('device', device)
  return device === device_type.Mobile || device === device_type.WebMobile
}

export const openCameraOCR = () => {
  return new Promise((resolve, reject) => {
    try {
      const checkDevice = handleDeviceDetection()
      if (checkDevice == device_type.Mobile) {
        window.ktaxaocr.callcheck(
          'CAMERA',
          function(response) {
            window.ktaxaocr.opencamera(
              function(res) {
                resolve(res)
              },
              function(res) {
                reject(res)
              }
            )
          },
          function(error) {
            reject(error)
          }
        )
      } else if (checkDevice == device_type.WebMobile) {
        resolve('res')
      } else {
        // Web
        resolve('res')
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const state_action = {
  consentinfo: 'consentinfo',
  camerainfo: 'camerainfo',
  opencamera_onweb: 'opencamara_onweb',
  opencamera_ondevice: 'opencamera_ondevice',
  pickerimage_onweb: 'pickerimage_onweb',
  pickerimage_ondevice: 'pickerimage_ondevice',
  previewimage: 'previewimage',
  loadingapi: 'loadingapi',
  resultapi: 'resultapi',
  doneflow: 'doneflow',
}
export const openPickerFile = () => {
  try {
    const checkDevice = handleDeviceDetection()
    if (checkDevice == device_type.Mobile) {
      window.ktaxaocr.callcheck(
        'PICKUPIMAGE',
        function(response) {
          window.ktaxaocr.pickerbookbank(
            (base64Image) => {},
            (error) => {}
          )
        },
        function(error) {}
      )
    } else {
    }
  } catch (error) {}
}
